import React from 'react';
import {
  Dialog, DialogTitle, DialogContent, DialogActions,
  Button, TextField, Typography, Box, Checkbox, CircularProgress,
} from '@mui/material';

const CreateInvoiceDialog = ({ open, onClose, newInvoice, onNewInvoiceChange, onSubmit, generatingInvoice }) => (
  <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
    <DialogTitle>Create New Invoice</DialogTitle>
    <DialogContent>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
        Generate a PDF invoice from approved items and disbursements.
      </Typography>

      <Box sx={{ mb: 2 }}>
        <Box display="flex" alignItems="center" gap={1}>
          <Checkbox
            checked={newInvoice.includeApprovedItems}
            onChange={(e) => onNewInvoiceChange({ ...newInvoice, includeApprovedItems: e.target.checked })}
          />
          <Typography>Include Approved Items</Typography>
        </Box>
        <Box display="flex" alignItems="center" gap={1}>
          <Checkbox
            checked={newInvoice.includeDisbursements}
            onChange={(e) => onNewInvoiceChange({ ...newInvoice, includeDisbursements: e.target.checked })}
          />
          <Typography>Include Approved Disbursements</Typography>
        </Box>
      </Box>

      <TextField
        fullWidth
        label="Tax Rate (%)"
        type="number"
        value={newInvoice.taxRate}
        onChange={(e) => onNewInvoiceChange({ ...newInvoice, taxRate: parseFloat(e.target.value) || 0 })}
        sx={{ mb: 2 }}
        inputProps={{ min: 0, max: 100, step: 0.1 }}
      />

      <TextField
        fullWidth
        label="Due Date (Optional)"
        type="date"
        value={newInvoice.dueDate}
        onChange={(e) => onNewInvoiceChange({ ...newInvoice, dueDate: e.target.value })}
        sx={{ mb: 2 }}
        InputLabelProps={{ shrink: true }}
      />

      <TextField
        fullWidth
        label="Notes (Optional)"
        multiline
        rows={3}
        value={newInvoice.notes}
        onChange={(e) => onNewInvoiceChange({ ...newInvoice, notes: e.target.value })}
        placeholder="Add any additional notes or payment instructions..."
      />
    </DialogContent>
    <DialogActions>
      <Button onClick={onClose}>Cancel</Button>
      <Button
        variant="contained"
        onClick={onSubmit}
        disabled={generatingInvoice || (!newInvoice.includeApprovedItems && !newInvoice.includeDisbursements)}
      >
        {generatingInvoice ? <CircularProgress size={24} /> : 'Create Invoice'}
      </Button>
    </DialogActions>
  </Dialog>
);

export default CreateInvoiceDialog;
